import get from 'app/common/lib/get';
import ejApi from 'app/actions/ejApi';
import i18n from 'app/i18n';


export const USER_REQUEST = 'eljur/USER_REQUEST';
export const USER_SUCCESS = 'eljur/USER_SUCCESS';
export const USER_FAILURE = 'eljur/USER_FAILURE';

const userRequest = () => ({
  type: USER_REQUEST,
});

const userSuccess = data => ({
  type: USER_SUCCESS,
  payload: data,
});

const userFailure = errString => ({
  type: USER_FAILURE,
  payload: { err: errString },
});

/**
* Запрос пользователя ЭлЖур
*/
export const ejUserFetch = (token, vendor) => async (dispatch) => {
  dispatch(userRequest());
  try {
    const res = await ejApi('getrules', 'get', { params: { auth_token: token, vendor } });
    dispatch(userSuccess(get(res, 'data.response', {})));
  } catch (error) {
    dispatch(userFailure(i18n.t('app:request_eljur_user_failed')));
  }
};
